import { Injectable } from "@angular/core";
import { environment } from "@edp-environments/environment";

@Injectable({
    providedIn: "root",
})
export class AppBannerService {

    public show() {
        return !environment.isApp && window.innerWidth < 480;
    }
}
